import React from 'react'
import { useGLTF } from '@react-three/drei'

function Monstera(props) {
    const { nodes } = useGLTF('/3d_objects/monstera.glb')
  
    React.useEffect(() => {
      props.setLoading(props.loading + 1)
    }, [nodes])
    
    return (
      <primitive object={nodes.Sketchfab_model} position={[5.2, 0.4, 0]} scale={[2, 2, 2]} />
    )
}
  
export default Monstera;